import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetchingContact = (state: IStore) => state.infoContact.isFetching;
const getFetchContactFailed = (state: IStore) => state.infoContact.isFetchFailed;
const getContactContent = (state: IStore) => state.infoContact.content;

export {
  getIsFetchingContact,
  getFetchContactFailed,
  getContactContent,
};


// WEBPACK FOOTER //
// ./src/components/InfoContact/Redux/selectors.tsx